import { makeStyles } from "@material-ui/core/styles";
import { preDefinedThemeColor } from "./preDefinedColor";
import { alpha } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
   justifyCenter:{
    [theme.breakpoints.down("sm")]:{
      justifyContent:"center"
    },
  },
  circleSize:{
    [theme.breakpoints.down("sm")]:{
      size:250
    },
  },
  scoreCardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  scoreCardHeaderDate: {
    color: "rgb(174, 178, 186)",
    fontSize: 15,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "auto",
    flexShrink: 0,
    fontWeight: 500,
  },
  headingDisabled: {
    color: "rgba(174, 178, 186, 1)",
  },
  secondaryHeading: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    color: "#000",
    fontSize: "1.5em",
    fontWeight: 500,
  },
  circularProgressSmall: {
    width: `${theme.typography.pxToRem(20)} !important`,
    height: `${theme.typography.pxToRem(20)} !important`,
  },
  accordionSummary: {
    padding: `${theme.spacing(2.5, 5)} !important`,
    maxHeight: "80px",
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
      justifyContent: "space-between",
    },
    "&.Mui-expanded": {
      minHeight: "64px",
      boxShadow: "0 1px 2px 2px rgba(0, 0, 0, 0.08)",
    },
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(2.5, 2.5)} !important`,
    },
  },
  accordionContainer: {
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "1px 0",
      background: "#fafbfc",
    },
  },
  accordionDetails: {
    padding: `${theme.spacing(0)} !important`,
    maxHeight: 430,
    overflow: "auto",
  },
  cardContentWrapper: {
    overflow: "auto",
  },
  cardContent: {
    //minWidth: 400,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    //padding: theme.spacing(3, 3, 3),
    "&:last-child": {
      padding: theme.spacing(3, 3, 3),
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: "100%",
      padding: theme.spacing(4, 4, 3),
      "&:last-child": {
        padding: theme.spacing(4, 4, 3),
      },
    },
  },
  graphContainer: {
    marginTop: "auto",
    marginBottom: "auto",
  },
  accordionWrapper: {
    "&:last-child": {
      padding: 0,
    },
  },
  cardTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(16),
      margin: "auto",
    },
  },
  cardTitleSubText: {
    color: 'rgb(174, 178, 186)',
    marginTop: 5,
  },
  cardDate: {
    margin: theme.spacing(2, 0, 4),
    textAlign: "center",
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
    color: "rgba(174, 178, 186, 1)",
    position: "absolute",
    top: "90%",
    left: "50%",
    transform: "translate(-50%, -100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: 180,
  },
  height100: {
    height: "100%",
  },
  scoreValue: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
    color: "#000",
    marginBottom: "6px",
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  scoreLabel: {
    fontSize: theme.typography.pxToRem(15),
    color: "rgba(174, 178, 186, 1)",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  engagementLabel: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 500,
    color: "rgba(46, 56, 77, 1)",
    display: "inline-flex",
    alignItems: "center",
  },
  scoreLabelCircle: {
    width: "18px",
    margin: "-5px 5px 0 0",
  },
  colorSuccess: {
    color: "rgb(159, 211, 86)",
  },
  colorError: {
    color: "rgb(212, 29, 24)",
  },
  colorPrimary: {
    color: theme.palette.primary.main,
  },
  scoreChip: {
    fontSize: theme.typography.pxToRem(40),
    fontWeight: 700,
    height: theme.typography.pxToRem(64),
    borderRadius: theme.typography.pxToRem(32),
    padding: theme.spacing(0, 2.5),
    lineHeight: 1,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, 0%)",
    backgroundColor: "rgb(241, 242, 246)",
    "& .MuiSvgIcon-root": {
      top: "0px!important",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(20),
      height: theme.typography.pxToRem(40),
      padding: theme.spacing(0, 1),
      minWidth: 95,
    },
  },
  errorMarker: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(48),
  },
  scoreValueSkeleton: {
    transform: "scale(1, 1) !important",
  },
  scoreChipSkeleton: {
    position: "absolute",
    top: "calc(50% - 20px)",
    left: "calc(50% - 66px)",
    borderRadius: "32px",
    transform: "scale(1, 1) !important",
  },
  scoreChipLoader: {
    position: "absolute",
    top: "calc(50% - 20px)",
    left: "calc(50% - 20px)",
  },
  chipLarge: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 700,
    height: theme.typography.pxToRem(40),
    borderRadius: 20,
    lineHeight: 1,
  },
  contentEngagementChip: {
    backgroundColor: preDefinedThemeColor.red,
    color: theme.palette.error.contrastText,
    fontSize: theme.typography.pxToRem(40),
    fontWeight: 700,
    height: "100%",
    borderRadius: theme.typography.pxToRem(45),
    padding: "30px 35px 20px",
    marginBottom: "20px",
    lineHeight: 1,
  },
  potenitalPenalityChipSkeleton: {
    borderRadius: "32px !important",
    transform: "scale(1,1) !important",
  },
  potenitalPenalityChip: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: 700,
    borderRadius: theme.typography.pxToRem(32),
    // padding: "32px 24px",
    lineHeight: 1,
    [theme.breakpoints.down("sm")]: {
      margin: "auto",
      fontSize: 14,
      padding: "16px 12px",
    },
  },
  potentialPenaltyText: {
    marginBottom: 0,
    fontWeight: 500,
    fontSize:'20px',
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: 12,
    },
  },
  contentEngagementLabel: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 500,
    color: "#000000",
  },
  contentEngagementImg: {
    textAlign: "right",
  },
  chipXLarge: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 700,
    height: theme.typography.pxToRem(60),
    borderRadius: 30,
    lineHeight: 1,
  },
  chipError: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    lineHeight: 1,
  },
  headingTitle: {
    fontSize: "1.4em",
    fontWeight: "bold",
  },
  severeEvents: {
    fontSize: "1.4em",
    fontWeight: 500,
    margin: "1em 0 0.5em",
  },
  headerSubNote: {
    textAlign: "right",
    color: "rgb(175 179 187)",
    marginBottom: theme.spacing(2.5),
    fontSize: 10,
    fontWeight: 500,
    [theme.breakpoints.up("sm")]: {
      fontSize: 15,
      fontWeight: 400,
    },
  },
  driverRiskList: {
    width: "100%",
    padding: 0,
  },
  driverRiskListItem: {
    borderBottom: "1px solid rgba(0,0,0,.1)",
    padding: theme.spacing(2, 5),
    "&.MuiListItem-root": {
      padding: theme.spacing(2, 5),
    },
    border: "1px solid rgb(241,242,246)",
    height: "80px",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 2.5),
      "&.MuiListItem-root": {
        padding: theme.spacing(2, 2.5),
      },
    },
  },
  driverRiskListItemText: {
    width: "50%",
    maxWidth: "50%",
    flex: "0 0 50%",
    fontSize: 14,
    fontWeight: 500,
    display: "flex",
    alignItems: "center",
    color: "rgba(36, 42, 56, 1)",
    "& .MuiTypography-body1": {
      fontWeight: 500,
      fontSize: 14,
      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
      },
    },
  },
  driverRiskListItemTextInner: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    "&, &.MuiAvatar-root": {
      backgroundColor: alpha(theme.palette.primary.main, 0.5),
      color: "#000",
      fontSize: ".85rem",
      fontWeight: 500,
    },
  },
  driverLink: {
    marginLeft: theme.spacing(2),
    textDecoration: "none",
    color: "rgba(36, 42, 56, 1)",
  },
  driverRiskListItemValue: {
    width: "50%",
    maxWidth: "50%",
    flex: "0 0 50%",
    fontSize: 15,
    color: "rgba(174, 178, 186, 1)",
    "& .MuiTypography-body1": {
      fontSize: 14,
      display: "block",
      [theme.breakpoints.down("sm")]: {
        fontSize: 10,
        marginLeft: theme.spacing(1),
      },
    },
  },
  arrowUpIcon: {
    marginRight: 5,
  },
  arrowDownIcon: {
    marginRight: 5,
  },
  arrowForwardIcon: {
    marginRight: 5,
  },
  trendingScoreList: {
    "& .MuiGrid-root.MuiGrid-item": {
      display: "inline-flex",
      [theme.breakpoints.down("xs")]: {
        width: "50%",
      },
      "& > div": {
        margin: "0 5px",
      },
    },
  },
  accordionSummaryTypeDriver: {
    cursor: "default !important",
  },
  accordionSummaryMarginRight: {
    marginRight: 35,
  },
  contentEngagementLegend: {
    fontSize: 15,
    color: "rgb(135,152,173)",
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
      marginTop: theme.spacing(1),
    },
  },
  graphBullet: {
    width: 10,
    height: 10,
    display: "block",
    borderRadius: "50%",
    margin: theme.spacing(1, 2.5),
    backgroundColor: "rgb(135,152,173)",
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(1),
    },
  },
  assignedContentBullet: {
    backgroundColor: "rgb(140, 84, 255)",
  },
  engagementContentBullet: {
    backgroundColor: "rgb(46, 91, 255)",
  },
  viewDetailLink: {
    fontSize: 16,
    fontWeight: 500,
  },
  viewDetailLinkDisabled: {
    fontSize: 16,
    fontWeight: 500,
    color: "rgba(174, 178, 186, 1)",
  },
  noRecordsText: {
    margin: "0 auto",
  },
  scoreDialWrapper: {
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  timeText: {
    fontSize: theme.typography.pxToRem(16),
    color: "rgb(174, 178, 186)",
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(14),
      margin: theme.spacing(1, "auto", 0),
    },
  },
  graphDisabled: {
    pointerEvents: "none",
  }, 
  penaltyPointsCardContent: {
    //minWidth: 400,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(3, 3, 3),
    "&:last-child": {
      padding: theme.spacing(3, 3, 3),
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: "100%",
      padding: theme.spacing(4, 4, 3),
      "&:last-child": {
        padding: theme.spacing(4, 4, 3),
      },
    },
  },
  penaltyPointsDashboard: {
    height: theme.spacing(10),
    width:'167px',
    // margin: theme.spacing(0.5, 1, 0.75, 0),
    backgroundColor: "rgba(227, 23, 23)",
    borderTopLeftRadius: '100px',
    borderBottomLeftRadius:'100px',
    display:'flex',
    alignItems:'center',
    justifyContent:'center'
},
penaltyPoints: {
  height: theme.spacing(10),
  width:'167px',
  // margin: theme.spacing(0.5, 1, 0.75, 0),
  backgroundColor: "rgba(0, 0, 0)",
  borderTopLeftRadius: '100px',
  borderBottomLeftRadius:'100px',
  display:'flex',
  alignItems:'center',
  justifyContent:'center'
},
penaltyPointsText:{
  fontSize: 40,
  color: "rgb(255, 255, 255)",
  fontWeight:500
}
}));
